import { IINValidationScheme } from '@/shared'
import { Formik, Form as FormikForm, Field as FormikField } from 'formik'
import { formFieldNames } from '@/entity'
import { Button, Field } from '@/ui'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import styles from '../VerificationSms.module.scss'
import { verificationThunks } from '@/entity/verification'
import { LoadingBlocker } from '@/components/Loader'

export const Step1 = () => {
	const dispatch = useDispatch()
	const { t } = useTranslation()

	const {phone} = useSelector(state => ({
		phone: state.verification.phone,
	}))

	const handleSend = (data) => {
		dispatch(verificationThunks.getPhoneForIin({ iin: data.iin }))
	}

	return (
		<>
			<Formik initialValues={{iin: null}} validationSchema={IINValidationScheme} onSubmit={handleSend}>
				{({ values, isValid }) => {
					return (
						<FormikForm>
							<div className={styles.flexMobile}>
								<div className={styles.fields}>
									<FormikField name={formFieldNames.iin}>
										{({ field, meta: { touched, error } }) => (
											<Field
												hideNumberArrows
												label={t('iin')}
												placeholder={t('enter_iin', { count: 12 })}
												error={touched && error}
												{...field}
												maxLength={12}
												pattern="[0-9]{12}"
												onInput={(e) => {
													e.target.value = e.target.value.replace(/[^0-9]/g, '')
												}}
											/>
										)}
									</FormikField>
								</div>
								<div className={styles.fieldAndButton}>
									<Button disabled={!isValid} type="submit">
										{t('send')}
									</Button>
								</div>
							</div>

							{phone.success && phone.data === null ? t('error_bmg') : null}
							<div className={styles.error}>{phone.error ? t('error_bmg_service') : null}</div>
						</FormikForm>
					)
				}}
			</Formik>

			{phone.loading && <LoadingBlocker />}
		</>
	)
}